// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2H5N8";
export var top = "styles-module--top--7_9Qv";
export var bottom = "styles-module--bottom--1T7YR";
export var shrink = "styles-module--shrink--2UHJg";
export var expand = "styles-module--expand--1q5T5";